<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { ControlPosition, IControl, Map } from 'mapbox-gl'
import { Icon } from '@iconify/vue2'
import { useMapBox } from './composables/useMapBox'

const props = defineProps<{
	position?: ControlPosition
}>()

let control: IControl | undefined

const zoomInButton = ref<HTMLElement>()
const zoomOutButton = ref<HTMLElement>()
const resetNorthButton = ref<HTMLElement>()

const { map } = useMapBox()

onMounted(() => {
	let container: HTMLDivElement

	control = {
		onAdd(map: Map) {
			container = document.createElement('div')
			container.className = 'mapboxgl-ctrl'

			zoomInButton.value?.addEventListener('click', () => map.zoomIn())
			zoomOutButton.value?.addEventListener('click', () => map.zoomOut())
			resetNorthButton.value?.addEventListener('click', () => map.resetNorth())

			container.appendChild(zoomInButton.value!)
			container.appendChild(zoomOutButton.value!)
			container.appendChild(resetNorthButton.value!)

			return container
		},
		onRemove() {
			container?.remove()
		},
	}

	setTimeout(() => map?.value?.addControl(control!, props.position || 'top-right'), 500)
})

onUnmounted(() => {
	if (control) map?.value?.removeControl(control)
})
</script>

<template>
	<div>
		<button
			style="border: 1px solid #737576; border-bottom: none"
			class="flex items-center justify-center w-8 h-8 rounded-t-md bg-white-neutral !hover:bg-white-neutral !border border-gray-medium"
			ref="zoomInButton"
		>
			<Icon
				class="text-xl"
				icon="material-symbols:add-rounded"
			/>
		</button>

		<button
			style="border: 1px solid #737576"
			class="flex items-center justify-center w-8 h-8 bg-white-neutral border border-gray-medium"
			ref="zoomOutButton"
		>
			<Icon
				class="text-xl"
				icon="material-symbols:remove-rounded"
			/>
		</button>
		<button
			style="border: 1px solid #737576; border-top: none"
			class="flex items-center justify-center w-8 h-8 rounded-b-md bg-white-neutral border border-gray-medium"
			ref="resetNorthButton"
		>
			<Icon
				class="text-xl text-gray-dark -rotate-[45deg]"
				icon="fa6-solid:compass"
			/>
		</button>
	</div>
</template>

<style>
.mapboxgl-ctrl button:hover {
	background-color: #fefefe !important;
	opacity: 0.95;
}
</style>
